import http from "@/services/CRMinitAuth"

const BASE_URL = `${process.env.VUE_APP_CRM_API}application_task_list/applications`;

export default {
  async fetchSystemTemplates() {
    const res = await http.get(`${BASE_URL}/notification_templates/email_labels/`);
    return res.map((item) => ({...item, readonly: true}));
  },
  async fetchAllTemplates() {
    const res = await http.get(`${BASE_URL}/notification_templates`);
    return res.map((item) => ({...item, readonly: false}));
  },
  async saveTemplates(data) {
    const res = await http.post(`${BASE_URL}/notification_templates/`, data);
    return res;
  },
  async updateTemplates(data) {
    const res = await http.put(`${BASE_URL}/notification_templates/${data.id}/`, data);
    return res;
  },
  async sendEmailToApplicant(data) {
    const res = await http.post(`${BASE_URL}/notifications/send_emails/`, data);
    return res;
  },
  async deleteEmailTemplate(id) {
    const res = await http.delete(`${BASE_URL}/notification_templates/${id}`);
    return res;
  }
};
